import { Container, styled } from '@mui/material';
import { TaskContext } from '../../context/TaskContext';

const PREFIX = 'TaskLayout';

export const classes = {
  messageBox: `${PREFIX}-messageBox`,
};

export const StyledTaskContextProvider = styled(TaskContext.Provider)({
  [`& .${classes.messageBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
});

export const StyledTaskLayout = styled('div')({
  background:
    'linear-gradient(254.7deg, #FFFFFF 50.36%, rgba(255, 255, 255, 0) 120.31%), url(/images/login-white-bg.jpg)',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
});

export const StyledTaskLayoutContainer = styled(Container)({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '90%',
})
